import { Component, computed, OnDestroy, OnInit, Signal, inject } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { DownloadAppButtonsComponent } from '../../../../shared/components/download-app-buttons/download-app-buttons.component';
import { EmployeeRoleType } from '../../../../_interfaces/employee.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { GoToStep } from '../../../../store/onboarding/onboarding.actions';
import { OnboardingSteps } from '../../../../store/onboarding/onboarding.model';
import { Store } from '@ngxs/store';
import { ReloadAppStateFromLogin } from '../../../../store/app/app.actions';
import { ProgressBarService } from '../../../../_services/progress-bar-service/progress-bar.service';

@Component({
  selector: 'app-employee-sign-up-success',
  imports: [NgOptimizedImage, DownloadAppButtonsComponent],
  templateUrl: './employee-sign-up-success.component.html',
})
export class EmployeeSignUpSuccessComponent implements OnInit, OnDestroy {
  readonly store = inject(Store);
  readonly route = inject(ActivatedRoute);
  readonly router = inject(Router);
  readonly progressBarService = inject(ProgressBarService);

  protected isAdminUser: Signal<boolean> = computed(() => {
    const queryParams = this.route.snapshot.queryParams;
    return queryParams['type'] === EmployeeRoleType.ADMIN;
  });

  constructor() {
    this.store.dispatch(new GoToStep(OnboardingSteps.SUCCESS));
  }

  ngOnInit() {
    this.progressBarService.setHideProgress(true); // Set to true to hide the progress bar
  }

  toDashboard() {
    this.store.dispatch(new ReloadAppStateFromLogin()).subscribe(() => this.router.navigate(['/dashboard']));
  }
  ngOnDestroy() {
    this.progressBarService.setHideProgress(false); // Set to false to show the progress bar
  }
}
